import whenDomReady from 'when-dom-ready';

import Animations from '../utils/Animations';

function initialise() {
  const elements = Array.from(document.querySelectorAll('[data-ds-anim]'));

  if (!elements || !elements.length) {
    return;
  }

  // eslint-disable-next-line
  new Animations(elements);
}

whenDomReady().then(initialise);
